export default {
  init() {
    // JavaScript to be fired on all pages 
  },
  finalize() {

  	window.onresize = doALoadOfStuff;

	function doALoadOfStuff() {
		
			$("#leads").slideReveal("hide")
	    
	}
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('a[href*="#"]')
	  // Remove links that don't actually link to anything
	  .not('[href="#"]')
	  .not('[href="#0"]')
	  .click(function(event) {
	    // On-page links
	    if (
	      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
	      && 
	      location.hostname == this.hostname
	    ) { 
	      // Figure out element to scroll to
	      var target = $(this.hash);
	      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	      // Does a scroll target exist?
	      if (target.length) {
	        // Only prevent default if animation is actually gonna happen
	        event.preventDefault();
	        $('html, body').animate({
	          scrollTop: target.offset().top  
	        }, 1000, function() {
	          // Callback after animation
	          // Must change focus!
	          var $target = $(target);
	          $target.focus();
	          if ($target.is(":focus")) { // Checking if the target was focused
	            return false;
	          } else {
	            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
	            $target.focus(); // Set focus again
	          };
	        });
	      }
	    }
	  });


	    $('a.expand').on('click', function(e) {
	    	console.log('click');
		    e.preventDefault();
		    var $this = $(this);
		    var $collapse = $this.closest('.collapse-group').find('.collapse');
		    $collapse.collapse('toggle');
		});

		$('a.mekkin').on('click', function(e) {
	    	e.preventDefault();
    		$('#mekkin').toggleClass('active');
		});

		$('#app-child a.expandapp').on('click', function(e) {
	    	e.preventDefault();
	    	$( this ).toggleClass( "active" )
		    var $this = $(this).data('href');
		    var blocknew = $this;
		    console.log(blocknew);
		    var $collapse = $('#block-'+blocknew).find('.collapse');  
		    $collapse.collapse('toggle');
		});

		$('#block-app-child a.expandapp').on('click', function(e) {
	    	e.preventDefault();
	    	$( this ).toggleClass( "active" )
		    var $this = $(this).data('href');
		    var blocknew = $this;
		    console.log(blocknew);
		    var $collapse = $('#block-'+blocknew).find('.collapse');  
		    $collapse.collapse('toggle');
		});
		/*
		$('a.tables').on('click', function(e) {
	    	
	    	e.preventDefault();
		    var $this = $(this).data('table');
		    var $thisid = $(this).data('id');
		    $('.tabela-img.'+$thisid+' img').attr('src',$this);
		    $( ".tabela-img img" ).fadeIn('slow');
		});
		*/
    $('.card-header').on('click',function(){
    	//console.log('teste');
    	if( $(this).find('span.oi').hasClass('oi-chevron-bottom') ){
    		$(this).find('span.oi').removeClass('oi-chevron-bottom');
    		$(this).find('span.oi').addClass('oi-chevron-top');
    	}else{
    		$(this).find('span.oi').removeClass('oi-chevron-top');
    		$(this).find('span.oi').addClass('oi-chevron-bottom');
    	}

    });

    $('[data-fancybox="gallery"]').fancybox({
		// Options will go here
	});		
    /*
	$( "main .section" ).each(function( index ) {
		$(this).addClass('block-'+index);
		
	  	$('#nav-lat ul').append('<li class="section-'+index+'"><a href="block-'+index+'"></a></li>');
	});

	$('#nav-lat ul li a').on('click',function(event){
		event.preventDefault();
		var elemento = $(this).attr('href');

		var new_position = $('main .'+elemento).offset();

		
		
        return false;
	});
	*/
	/*FEEDBACK*/
	$("#leads").slideReveal({
	  trigger: $("#trigger"),
	  position: "right",
	  push: false,
  	  overlay: true,
  	  width: '30%'
	});
	$("#trigger2").on('click',function(){
		$("#leads").slideReveal("toggle");
	});
	/*HOTSPOT*/
	$('button#hotspot').on('click',function(){
		var src = $(this).data('tabela');
		var tit = $(this).data('titulo');
		$('.link a').html(tit+' >');
		$('.link a').attr('data-table',src);
		$('.link a').attr('href',src);
		$('.link a').removeClass('d-none');
	});
	 

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js